import { render, staticRenderFns } from "./HeadlinesBanner.vue?vue&type=template&id=4e7367ee&scoped=true"
import script from "./HeadlinesBanner.vue?vue&type=script&lang=js"
export * from "./HeadlinesBanner.vue?vue&type=script&lang=js"
import style0 from "./HeadlinesBanner.vue?vue&type=style&index=0&id=4e7367ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7367ee",
  null
  
)

export default component.exports